import { reactive } from 'vue';
import { mapGetters } from 'vuex'
import {CampaignsService, CampaignsServicePublicFunctions} from '@/services/campaigns.service';
import { getCampaignsState, consumeLegacyLocalStorageCampaigns } from '@/storage/campaignsIndexedDb.js';

const storeDefault = {
  loading:false,
  pullingData:false,
  updating:false,
  newCreatives: {},
  listHasMore: true,
  listPage: null,
  listTotalCount: null,
  listSearch: null,
  listView: 'mine',
};

const store = reactive(Object.assign({ campaigns: [] }, storeDefault));

/**
 * Loads cached campaigns: legacy `localStorage['campaigns']` (read once, then removed), else IndexedDB.
 * When IndexedDB is unavailable, nothing else is persisted (in-memory only for that session).
 * Call before app mount so initial UI matches previous session.
 */
export async function hydrateCampaignsFromIndexedDb() {
  const fromLegacy = consumeLegacyLocalStorageCampaigns();
  const saved = fromLegacy || (await getCampaignsState());
  if (saved && typeof saved === 'object') {
    Object.assign(store, saved, storeDefault);
  }
}



export const campaigns = {
  namespaced: true,
  state: store,
  mounted() {

  },
  computed: {
    ...mapGetters('store',[
      ...CampaignsServicePublicFunctions
    ])
  },
  getters: {
    ...CampaignsService
  }

};
